module.exports = __webpack_public_path__ + "static/media/arrow-square-down.28d0ca7f.svg";